import React from "react"
import { FaBalanceScale, FaFileAlt, FaFileContract } from "react-icons/fa"


const MOCK = {
  processo: "5000947-35.2024.4.03.0000",
  situacao: "Suspenso / Sobrestado",
  dataSituacao: "26/05/2025",
  tipo: "Judicial",
  objeto: "Garantia do Juízo",
  esfera: "Cível/Fiscal",
  valorCausa: "R$ 1.250.000,00",
  tribunal: "Tribunal Regional Federal da 3ª Região (TRF3)",
  classificacao: "Execução Fiscal",
  cliente: "EMPRESA EXEMPLO COMÉRCIO LTDA",
  parteContraria: "UNIÃO FEDERAL",
  processosRelacionados: "5000519-53.2024.4.03.0000",
  oportunidade: "Renovação",
  resumo:
    "Execução fiscal promovida pela União em face da empresa Exemplo Comércio Ltda, referente a débitos tributários de PIS/COFINS. Trata-se de uma oportunidade de renovação de apólice de seguro garantia judicial, visando a manutenção da garantia oferecida ao juízo durante o trâmite processual.\n\nPonto relevante: a apólice vigente vence em 01/01/2026, sendo necessária a renovação antecipada para evitar a perda da garantia oferecida.",
  apolice: {
    seguradora: "Seguradora Exemplo S.A.",
    corretora: "Corretora Exemplo Ltda",
    importancia: "1.250.000,00",
    premio: "R$ 25.000,00",
    taxa: "2,00%",
    inicio: "01/01/2024",
    fim: "01/01/2026",
  },
}

const Field = ({ label, value, fullWidth }) => (
  <div style={{ marginBottom: 5, gridColumn: fullWidth ? "1 / -1" : undefined }}>
    <span style={{ fontWeight: 700, fontSize: 9, color: "#333" }}>{label}: </span>
    <span style={{ fontSize: 9, color: "#444" }}>{value}</span>
  </div>
)

const PreviewPDF = ({ template }) => {
  const primary = template.CorPrimaria || "#B68749"
  const secondary = template.CorSecundaria || "#f5e6d0"
  const logoUrl = template.LogoPath || null

  return (
    <div
      style={{
        width: 555,
        backgroundColor: "#fff",
        fontFamily: "Helvetica, Arial, sans-serif",
        boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
      }}
    >
      {/* Header */}
      <div style={{ padding: "14px 20px 0", backgroundColor: "#fff" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 9.5, color: "#555", marginBottom: 4 }}>
              <strong>Processo:</strong> {MOCK.processo}
            </div>
            <div style={{ fontSize: 26, fontWeight: 700, color: "#000", lineHeight: 1.1 }}>
              Insight Report
            </div>
            <div style={{ fontSize: 12.5, color: primary, marginTop: 3, fontWeight: 400 }}>
              Oportunidade Garantia Judicial
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", minWidth: 120, minHeight: 50 }}>
            {logoUrl ? (
              <img
                src={logoUrl}
                alt="logo"
                style={{ maxHeight: 52, maxWidth: 130, objectFit: "contain" }}
              />
            ) : (
              <div
                style={{
                  width: 100,
                  height: 42,
                  border: `2px dashed ${primary}`,
                  borderRadius: 4,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 9,
                  color: primary,
                }}
              >
                Logo
              </div>
            )}
          </div>
        </div>
        <div style={{ height: 2, backgroundColor: primary, marginTop: 10 }} />
      </div>

      {/* Info Grid */}
      <div style={{ padding: "10px 20px 6px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: 20,
          }}
        >
          <Field label="Situação" value={MOCK.situacao} />
          <Field label="Data Situação" value={MOCK.dataSituacao} />
          <Field label="Tipo" value={MOCK.tipo} />
          <Field label="Objeto" value={MOCK.objeto} />
          <Field label="Esfera" value={MOCK.esfera} />
          <Field label="Valor da Causa" value={MOCK.valorCausa} />
          <Field label="Tribunal" value={MOCK.tribunal} />
          <Field label="Classificação Processo" value={MOCK.classificacao} />
          <Field label="Cliente" value={MOCK.cliente} />
          <Field label="Parte Contrária" value={MOCK.parteContraria} />
          <Field label="Processos Relacionados" value={MOCK.processosRelacionados} fullWidth />
        </div>
      </div>

      {/* Oportunidade */}
      <div
        style={{
          margin: "0 20px 8px",
          backgroundColor: secondary,
          borderRadius: 8,
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}
      >
        <FaBalanceScale size={20} color={primary} />
        <span style={{ fontSize: 11, fontWeight: 700 }}>Oportunidade:</span>
        <span style={{ fontSize: 11 }}>{MOCK.oportunidade}</span>
      </div>

      {/* Resumo */}
      <div
        style={{
          margin: "0 20px 8px",
          border: `1px solid ${primary}`,
          borderRadius: 8,
          padding: "10px 14px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <FaFileAlt size={18} color={primary} />
          <span style={{ fontSize: 11, fontWeight: 700 }}>Resumo:</span>
        </div>
        {MOCK.resumo.split("\n\n").map((p, i) => (
          <p key={i} style={{ fontSize: 8.5, color: "#333", lineHeight: 1.6, margin: i > 0 ? "6px 0 0" : 0 }}>
            {p}
          </p>
        ))}
      </div>

      {/* Apólice no Processo */}
      <div style={{ margin: "0 20px 8px" }}>
        <div
          style={{
            backgroundColor: secondary,
            borderRadius: 8,
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <FaFileContract size={18} color={primary} />
          <span style={{ fontSize: 11, fontWeight: 700 }}>Apólice no Processo:</span>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 7.5 }}>
          <thead>
            <tr>
              {[
                "Seguradora",
                "Corretora",
                "Importância Segurada",
                "Prêmio",
                "Taxa",
                "Início da Vigência",
                "Fim da Vigência",
              ].map(h => (
                <th
                  key={h}
                  style={{
                    color: "#222",
                    fontWeight: 700,
                    textAlign: "center",
                    padding: "4px 6px",
                    borderTop: "1px solid #999",
                    borderBottom: "1px solid #999",
                    fontSize: 7.5,
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {[
                MOCK.apolice.seguradora,
                MOCK.apolice.corretora,
                MOCK.apolice.importancia,
                MOCK.apolice.premio,
                MOCK.apolice.taxa,
                MOCK.apolice.inicio,
                MOCK.apolice.fim,
              ].map((v, i) => (
                <td
                  key={i}
                  style={{
                    padding: "4px 6px",
                    borderBottom: "1px solid #ccc",
                    color: "#333",
                    textAlign: "center",
                    fontSize: 7.5,
                  }}
                >
                  {v}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div style={{ height: 38, backgroundColor: primary, marginTop: 14 }} />
    </div>
  )
}

export default PreviewPDF
